import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            
            <b>Need someone who can build, fix, or level up your tech?</b>
            <br /><br />
            I’m Rochdi — a self-employed software engineer who turns ideas into real, working software.
            <br /><br />
            I specialize in building full-stack web apps using Python, Django, and modern JavaScript frameworks like React. I also handle machine learning workflows, API integrations, and database design — basically, if it involves code and a challenge, I’m into it.
            <br /><br />
            Beyond the keyboard, I write about tech, play chess competitively, and enjoy learning new things that make me a better builder.
            <br /><br />
            If you're looking for someone to help with your project — whether it's a web app, a custom script, or just an idea you want to prototype — I'm available for freelance work and collaborations.
            <br /><br />
            Let’s make something great together.
          </p>

        

          <p style={{ color: "rgb(255 255 255)" }}>
            "The best way to predict the future is to invent it."
          </p>
          <footer className="blockquote-footer">Alan Kay</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
